import { render, staticRenderFns } from "./EditPublicationBasedAdFormat.vue?vue&type=template&id=1e47aff1&"
import script from "./EditPublicationBasedAdFormat.vue?vue&type=script&lang=js&"
export * from "./EditPublicationBasedAdFormat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports